<template>
	<div class="banners" :class="{top, bottom}">
		<div
			class="banners-banner"
			v-for="banner in banners"
			:key="banner.id"
			:style="{'background-color': banner.backgroundColor}"
			:data-card-title="banner.title"
			:data-card-type="banner.type"
			:data-card-subtype="banner.subtype"
		>
			<span class="banners-banner-text" v-html="$processText(banner.wysiwyg)"></span>
			<div class="banners-banner-close" @click="closeBanner(banner)">
			    <img src="@/assets/img/clear-white.png" width="18">
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Banners',
    props: ['top', 'bottom'],

    data() {
    	return {
			
    	}
    },

    methods: {
    	closeBanner(banner) {
    		this.$set(banner, 'closed', true)

            this.$metric({'event': 'banner_interaction', 'InteractionType': 'closed'})

    	    this.$nextTick(() => this.$store.state.filterHeight = this.$parent.$refs.middle.clientHeight)
    	},
    },

    computed: {
    	banners() {
    	    let bottomBanners = this.$store.getters.cards.filter(c => c.type === 'menu_bottom_banner' && ! c.closed)

    	    bottomBanners = bottomBanners.map(bB => {
    	        let parentLayer = this.$store.state.layers.find(l => l.id === bB.layer_id)

    	        if ( ! parentLayer.active) {
    	            return null
    	        }

    	        bB.backgroundColor = parentLayer.icon_font_color

    	        return bB
    	    }).filter(bB => bB)

    	    return bottomBanners
    	},
    }
}
</script>